<section class="about-container">
  <h1 class="text-primary">{{ 'ABOUT_US_TITLE' | translate }}</h1>
  <p class="fs-5 mb-5">
    {{ 'ABOUT_US_CONTENT' | translate }}
  </p>

  <h1 class="text-primary">{{ 'CONTACT_US_TITLE' | translate }}</h1>
  <p class="fs-5 mb-5">
    {{ 'CONTACT_US_EMAIL' | translate }}
    <strong class="cursor-poiner"
      ><i class="bi bi-envelope"></i>
      <a href="mailto:support@company.com"> info&#64;bazar-s.com</a>
    </strong>
  </p>
  <p class="fs-5 mb-5">
    {{ 'CONTACT_US_WHATSAPP' | translate }}
    <strong class="cursor-poiner" (click)="openWhatsApp('41762768797')"
      ><i class="bi bi-whatsapp text-success"></i> 0041762768797
    </strong>
  </p>
  <div class="fs-5 mb-5">
    {{ 'CONTACT_US_SOCIAL_MEDIA' | translate }}
    <ol class="py-4 d-flex justify-content-center">
      <li>
        <a
          href="https://www.facebook.com/profile.php?id=61588939880032"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="bi bi-facebook fs-3"></i
        ></a>
      </li>

      <li>
        <a href="https://www.instagram.com/bazar.syria/" target="_blank" rel="noopener noreferrer"
          ><i class="bi bi-instagram fs-3"></i
        ></a>
      </li>
      <!-- <li>
        <a href="#"><i class="bi bi-tiktok fs-3"></i></a>
      </li> -->
    </ol>
  </div>

  <section class="pricing-section" aria-labelledby="pricing-title">
    <h2 id="pricing-title" class="pricing-title text-primary">{{ 'PACKAGES' | translate }}</h2>
    <div class="pricing-grid">
      <article class="pricing-card" aria-labelledby="plan-flex">
        <header class="pricing-card-heading">
          <h3 id="plan-flex">{{ 'FLEX' | translate }}</h3>
          <p>{{ 'FLEX_SUB_TITLE' | translate }}</p>
        </header>
        <div class="pricing-card-price">
          <div class="pricing-original"></div>
          <p class="pricing-amount">
            <bdi>{{ 'FLEX_DISCOUNT_PRICE' | translate }}</bdi>
          </p>
          <div class="pricing-offer"></div>
        </div>
        <ul class="pricing-features">
          <li>
            <span>{{ 'FLEX_FEATURE_1' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Flex, 1) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'FLEX_FEATURE_2' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Flex, 2) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'FLEX_FEATURE_3' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Flex, 3) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'FLEX_FEATURE_4' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Flex, 4) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'FLEX_FEATURE_5' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Flex, 5) + '%'" aria-hidden="true"></span>
          </li>
        </ul>
      </article>
      <article class="pricing-card" aria-labelledby="plan-pro">
        <header class="pricing-card-heading">
          <h3 id="plan-pro">{{ 'PRO' | translate }}</h3>
          <p>{{ 'PRO_SUB_TITLE' | translate }}</p>
        </header>
        <div class="pricing-card-price">
          <div class="pricing-original">
            <s
              ><bdi>{{ 'PRO_PRICE' | translate }}</bdi></s
            >
          </div>
          <p class="pricing-amount">
            <bdi>{{ 'PRO_DISCOUNT_PRICE' | translate }}</bdi>
          </p>
          <div class="pricing-offer">
            <span>{{ '2026_OFFER' | translate }}</span>
          </div>
        </div>
        <ul class="pricing-features">
          <li>
            <span>{{ 'PRO_FEATURE_1' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Pro, 1) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'PRO_FEATURE_2' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Pro, 2) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'PRO_FEATURE_3' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Pro, 3) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'PRO_FEATURE_4' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Pro, 4) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'PRO_FEATURE_5' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Pro, 5) + '%'" aria-hidden="true"></span>
          </li>
        </ul>
      </article>
      <article class="pricing-card" aria-labelledby="plan-unlimited">
        <header class="pricing-card-heading">
          <h3 id="plan-unlimited">{{ 'UNLIMITED' | translate }}</h3>
          <p>{{ 'UNLIMITED_SUB_TITLE' | translate }}</p>
        </header>
        <div class="pricing-card-price">
          <div class="pricing-original">
            <s
              ><bdi>{{ 'UNLIMITED_PRICE' | translate }}</bdi></s
            >
          </div>
          <p class="pricing-amount">
            <bdi>{{ 'UNLIMITED_DISCOUNT_PRICE' | translate }}</bdi>
          </p>
          <div class="pricing-offer">
            <span>{{ '2026_OFFER' | translate }}</span>
          </div>
        </div>
        <ul class="pricing-features">
          <li>
            <span>{{ 'UNLIMITED_FEATURE_1' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Unlimited, 1) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'UNLIMITED_FEATURE_3' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Unlimited, 3) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'UNLIMITED_FEATURE_2' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Unlimited, 2) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'UNLIMITED_FEATURE_4' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Unlimited, 4) + '%'" aria-hidden="true"></span>
          </li>
          <li>
            <span>{{ 'UNLIMITED_FEATURE_5' | translate }}</span>
            <span class="package-tier-bar" [style.--package-benefit]="benefitProgress(plans.Unlimited, 5) + '%'" aria-hidden="true"></span>
          </li>
        </ul>
      </article>
    </div>
  </section>
</section>
